import React, { ReactNode } from "react";
import PssLogoPicture from "../features/pss-logo/view/PssLogoPicture";
import { PssRoutePath } from "./_pss.route-path";
import PssAssigneeDetails from "../features/pss-assignee/views/components/PssAssigneeDetails";

// Aunthentication
const PssNotFoundError = React.lazy(
  () => import("../features/errors/PssNotFoundError"),
);
const PssInternalServerError = React.lazy(
  () => import("../features/errors/PssInternalServerError"),
);

// Dashboard
const PssDashboard = React.lazy(
  () => import("../features/dashboard/views/Dashboard"),
);

// Profile
const PssProfile = React.lazy(
  () => import("../features/profile/view/PssProfile"),
);
const PssProfileAccount = React.lazy(
  () => import("../features/profile/view/components/PssProfile.AccountPass"),
);

// Compound Access
const PssCompoundAccessGate = React.lazy(
  () => import("../features/compound-access/PssCompoundAccess.Gate"),
);
const PssCompoundAccessGateById = React.lazy(
  () => import("../features/compound-access/PssCompoundAccess.Gate.ById"),
);
const PssCompoundAccessHistoryLog = React.lazy(
  () => import("../features/compound-access/PssCompoundAccess.HistoryLog"),
);
const PssCompoundAccessHistoryLogPrint = React.lazy(
  () =>
    import(
      "../features/compound-access/PssCompoundAccess.HistoryLog.Table.Print"
    ),
);
const PssCompoundAccessSuspiciousLog = React.lazy(
  () => import("../features/compound-access/PssCompoundAccess.SuspiciousLog"),
);
const PssCompoundAccessSuspiciousLogPrint = React.lazy(
  () => import("../features/compound-access/PssCompoundAccess.SuspiciousLog.Table.Print"),
);

const PssCompoundAccessManage = React.lazy(
  () => import("../features/compound-access/PssCompoundAccess.Manage"),
);

// Door Access
const PssDoorAccess = React.lazy(
  () => import("../features/door-access/PssDoorAccess.Door"),
);
const PssDoorAccessHistoryLog = React.lazy(
  () => import("../features/door-access/PssDoorAccess.HistoryLog"),
);
const PssDoorAccessManagement = React.lazy(
  () => import("../features/door-access/PssDoorAccess.Manage"),
);
const PssDoorAccessManagementDetails = React.lazy(
  () => import("../features/door-access/PssDoorAccess.Manage.Details"),
);

// Access Group
const PssAccessGroup = React.lazy(
  () => import("../features/access-group/views/Components/PssAccessGroup"),
);
const PssAccessGroupUserRegistration = React.lazy(
  () =>
    import("../features/access-group/views/PssAccessGroup.User.Registration"),
);
const PssAccessGroupUserAccount = React.lazy(
  () => import("../features/access-group/views/PssAccessGroup.User.Account"),
);

// User Management
const PssUserManagement = React.lazy(
  () => import("../features/user-management/views/PssUserManagement"),
);
const PssUserManagementRoleRegistration = React.lazy(
  () =>
    import(
      "../features/user-management/views/components/PssUserManagement.Role.Registration"
    ),
);

const PssUserList = React.lazy(
  () => import("../features/user-management/views/PssUserManagement.ById"),
);

// APRS
// Attendance
const PssAprsAttendance = React.lazy(
  () => import("../features/aprs-attendance/views/PssAprsAttendance"),
);
const PssAprsAttendanceRegister = React.lazy(
  () => import("../features/aprs-attendance/views/PssAprsAttendance.Register"),
);
const PssAprsAttendanceEdit = React.lazy(
  () => import("../features/aprs-attendance/views/PssAprsAttendance.Edit"),
);
const PssAprsAttendanceGeneral = React.lazy(
  () => import("../features/aprs-attendance/views/PssAprsAttendance.General"),
);
const PssAprsAttendanceGeneralPrint = React.lazy(
  () =>
    import("../features/aprs-attendance/views/PssAprsAttendance.General.Print"),
);
const PssAprsAttendanceOvertime = React.lazy(
  () => import("../features/aprs-attendance/views/PssAprsAttendance.Overtime"),
);
const PssAprsAttendanceOvertimePrint = React.lazy(
  () =>
    import(
      "../features/aprs-attendance/views/PssAprsAttendance.Overtime.Print"
    ),
);
const PssAprsAttendanceManage = React.lazy(
  () => import("../features/aprs-attendance/views/PssAprsAttendance.Manage"),
);

// Device Call
const PssAprsDeviceCall = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice"),
);
const PssAprsDeviceTablePrint = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.TablePrint"),
);
const PssAprsDeviceCallRecord = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.Record"),
);
const PssAprsDeviceRecordTablePrint = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDeviceRecord.TablePrint"),
);
const PssAprsDeviceCallRegister = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.Registration"),
);
const PssAprsDeviceCallDetail = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.Detail"),
);
const PssAprsDeviceCallDetailRecord = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.RecordDetail"),
);
const PssAprsDeviceCallPrint = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.Print"),
);
const PssAprsDeviceCallRecordPrint = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.RecordPrint"),
);
const PssAprsDeviceCallManage = React.lazy(
  () => import("../features/aprs-device/views/PssAprsDevice.Manage"),
);

// Vehicle
const PssAprsVehicle = React.lazy(
  () => import("../features/aprs-vehicle/views/PssAprsVehicle"),
);
const PssAprsVehicleDetail = React.lazy(
  () => import("../features/aprs-vehicle/views/PssAprsVehicle.ById"),
);
const PssAprsVehiclePrint = React.lazy(
  () => import("../features/aprs-vehicle/views/PssAprsVehicle.Print"),
);
const PssAprsVehicleManage = React.lazy(
  () => import("../features/aprs-vehicle/views/PssAprsVehicle.Manage"),
);

// UCUX
const PssAprsUcux = React.lazy(
  () => import("../features/aprs-ucux/views/PssAprsUcux"),
);
const PssAprsUcuxPrintListPreview = React.lazy(
  () => import("../features/aprs-ucux/views/PssAprsUcux.PrintListPreview"),
);
const PssAprsUcuxPrintById = React.lazy(
  () => import("../features/aprs-ucux/views/PssAprsUcux.PrintReport"),
);
const PssAprsUcuxById = React.lazy(
  () => import("../features/aprs-ucux/views/PssAprsUcux.ById.Detail"),
);
const PssAprsUcuxManage = React.lazy(
  () => import("../features/aprs-ucux/views/PssAprsUcux.Manage"),
);
const PssAprsUcuxOffenseDetail = React.lazy(
  () => import("../features/aprs-ucux/views/PssAprsUcux.Manage.OffenseDetail"),
);

// PssAprsReferences
const PssAprsReferencesAddressPhoneNo = React.lazy(
  () =>
    import(
      "../features/aprs-references/address-phonenumber/views/PssAprsRefAddressPhoneNo"
    ),
);
const PssAprsReferencesAddressPhoneNoRegister = React.lazy(
  () =>
    import(
      "../features/aprs-references/address-phonenumber/views/PssAprsRefAddressPhoneNo.Register"
    ),
);
const PssAprsReferencesAddressPhoneNoAccount = React.lazy(
  () =>
    import(
      "../features/aprs-references/address-phonenumber/views/PssAprsRefAddressPhoneNo.Editor"
    ),
);
const PssAprsReferencesCompanyVehicle = React.lazy(
  () =>
    import(
      "../features/aprs-references/company-vehicle/views/PssAprsRefCompanyVehicle"
    ),
);
const PssAprsReferencesCompanyVehicleRegister = React.lazy(
  () =>
    import(
      "../features/aprs-references/company-vehicle/views/PssAprsRefCompanyVehicle.Register"
    ),
);
const PssAprsReferencesCompanyVehicleAccount = React.lazy(
  () =>
    import(
      "../features/aprs-references/company-vehicle/views/PssAprsRefCompanyVehicle.Editor"
    ),
);
const PssAprsReferencesQuestion = React.lazy(
  () => import("../features/aprs-references/faq/views/PssAprsRefQuestion"),
);
const PssAprsReferencesQuestionRegister = React.lazy(
  () =>
    import("../features/aprs-references/faq/views/PssAprsRefQuestion.Register"),
);
const PssAprsReferencesQuestionAccount = React.lazy(
  () =>
    import("../features/aprs-references/faq/views/PssAprsRefQuestion.Editor"),
);
//SOP
const PssAprsReferencesSop = React.lazy(
  () => import("../features/aprs-references/SOP/views/PssAprsRefSop"),
);
const PssAprsReferencesSopRegister = React.lazy(
  () =>
    import("../features/aprs-references/SOP/views/PssAprsRefSop.Register"),
);
const PssAprsReferencesSopAccount = React.lazy(
  () => import("../features/aprs-references/SOP/views/PssAprsRefSop.Editor"),
);
//mfsp

const PssAprsReferencesMfsp = React.lazy(
  () => import("../features/aprs-references/mfsp/views/PssAprsRefMfsp"),
);
const PssAprsReferencesMfspRegister = React.lazy(
  () =>
    import("../features/aprs-references/mfsp/views/PssAprsRefMfsp.Register"),
);
const PssAprsReferencesMfspAccount = React.lazy(
  () => import("../features/aprs-references/mfsp/views/PssAprsRefMfsp.Editor"),
);
const PssAprsReferencesPoliceLaw = React.lazy(
  () =>
    import("../features/aprs-references/police-law/views/PssAprsRefPoliceLaw"),
);
const PssAprsReferencesPoliceLawRegister = React.lazy(
  () =>
    import(
      "../features/aprs-references/police-law/views/PssAprsRefPoliceLaw.Register"
    ),
);
const PssAprsReferencesPoliceLawAccount = React.lazy(
  () =>
    import(
      "../features/aprs-references/police-law/views/PssAprsRefPoliceLaw.Editor"
    ),
);
const PssAprsReferencesIsps = React.lazy(
  () => import("../features/aprs-references/isps/view/PssAprsRefIsps"),
);
const PssAprsReferencesIspsRegister = React.lazy(
  () => import("../features/aprs-references/isps/PssAprsRefIsps.Register"),
);
const PssAprsReferencesIspsAccount = React.lazy(
  () => import("../features/aprs-references/isps/PssAprsRefIsps.Editor"),
);
const PssAprsReferencesIspsDetail = React.lazy(
  () => import("../features/aprs-references/isps/view/PssAprsRefIsps.Detail"),
);
const PssAprsUserRecords = React.lazy(
  () => import("../features/user-records/view/PssAprsUserRecords"),
);

const PssAprsUserRecordsDetail = React.lazy(
  () => import("../features/user-records/view/PssAprsUserRecordDetail"),
);

const PssAprsVehicleRecords = React.lazy(
  () => import("../features/vehicle-records/view/PssAprsVehicleRecords"),
);

export type route = {
  component?: ReactNode;
  name?: string;
  key?: string;
  path?: string;
  routes?: route[];
  ids?: string[];
  disabled?: undefined | boolean;
};

const pssRoutes = [
  { path: PssRoutePath.Home, name: "Home" },
  { path: PssRoutePath.Dashboard, name: "Dashboard", component: PssDashboard },
  {
    path: PssRoutePath.Dashboard,
    name: "Dashboard",
    component: PssDashboard,
  },
  {
    path: PssRoutePath.NotFoundError,
    name: "Page Not Found",
    component: PssNotFoundError,
  },
  {
    path: PssRoutePath.InternalServerError,
    name: "Internal Server Error",
    component: PssInternalServerError,
  },
  // Profile
  {
    path: PssRoutePath.Profile,
    name: "Profile",
    component: PssProfile,
  },
  {
    path: PssRoutePath.ProfileAccount,
    name: "Profile Account",
    ids: ["userId"],
    component: PssProfileAccount,
  },
  // Compound Access
  {
    path: PssRoutePath.CompoundAccessGate,
    name: "Compound Access",
    component: PssCompoundAccessGate,
  },
  {
    path: PssRoutePath.CompoundAccessGate,
    name: "Compound Access",
    component: PssCompoundAccessGate,
  },
  {
    path: PssRoutePath.CompoundAccessGateById,
    name: "Visitor List",
    ids: ["gateId"],
    component: PssCompoundAccessGateById,
  },
  {
    path: PssRoutePath.CompoundAccessHistoryLog,
    name: "History Log",
    component: PssCompoundAccessHistoryLog,
  },
  {
    path: PssRoutePath.CompoundAccessHistoryLogPrint,
    name: "History Log Print",
    component: PssCompoundAccessHistoryLogPrint,
  },
    {
    path: PssRoutePath.CompoundAccessSuspiciousLog,
    name: "Suspicious Log",
    component: PssCompoundAccessSuspiciousLog,
  },
  {
  path: PssRoutePath.CompoundAccessSuspiciousLogPrint, // "/compoundAccess/suspiciousLog/print"
  name: "Suspicious Log Print",
  component: PssCompoundAccessSuspiciousLogPrint,
},
  {
    path: PssRoutePath.CompoundAccessManage,
    name: "Gate Management",
    component: PssCompoundAccessManage,
  },
  // Door Access
  {
    path: PssRoutePath.DoorAccess,
    name: "Door Access Door",
    component: PssDoorAccess,
  },
  {
    path: PssRoutePath.DoorAccessHistoryLog,
    name: "History Log",
    component: PssDoorAccessHistoryLog,
  },
  {
    path: PssRoutePath.DoorAccessManagement,
    name: "Door Access Management",
    component: PssDoorAccessManagement,
  },
  {
    path: PssRoutePath.DoorAccessManagementDetails,
    name: "Door Detail",
    ids: ["doorId"],
    component: PssDoorAccessManagementDetails,
  },
  // Access Group
  {
    path: PssRoutePath.AccessGroup,
    name: "Access Group Management",
    component: PssAccessGroup,
  },
  {
    path: PssRoutePath.AccessGroupUserRegistration,
    name: "Registration",
    component: PssAccessGroupUserRegistration,
  },
  {
    path: PssRoutePath.AccessGroupUser,
    name: "User: ",
    key: "userGroupId",
    ids: ["userGroupId"],
    disabled: true,
  },
  {
    path: PssRoutePath.AccessGroupUserAccount,
    name: "Account",
    ids: ["userGroupId"],
    component: PssAccessGroupUserAccount,
  },
  // User Management
  {
    path: PssRoutePath.UserManagement,
    name: "User Management",
    component: PssUserManagement,
  },
  {
    path: PssRoutePath.UserManagementRoleRegistration,
    name: "Registration",
    component: PssUserManagementRoleRegistration,
  },
  {
    path: PssRoutePath.UserList,
    name: "List of Users by Role",
    ids: ["userId"],
    component: PssUserList,
  },
  // APRS
  // Attendance
  {
    path: PssRoutePath.AprsAttendance,
    name: "Attendance Record",
    component: PssAprsAttendance,
  },
  {
    path: PssRoutePath.AprsAttendanceRecordRegister,
    name: "Registration",
    component: PssAprsAttendanceRegister,
  },
  {
    path: PssRoutePath.AprsAttendanceRecordEdit,
    name: "Edit",
    component: PssAprsAttendanceEdit,
  },
  {
    path: PssRoutePath.AprsAttendanceGeneral,
    name: "Attendance General",
    component: PssAprsAttendanceGeneral,
  },
  {
    path: PssRoutePath.AprsAttendanceGeneralPrint,
    name: "Attendance General Print",
    component: PssAprsAttendanceGeneralPrint,
  },
  {
    path: PssRoutePath.AprsAttendanceOvertime,
    name: "Attendance Overtime",
    component: PssAprsAttendanceOvertime,
  },
  {
    path: PssRoutePath.AprsAttendanceOvertimePrint,
    name: "Attendance Overtime Print",
    component: PssAprsAttendanceOvertimePrint,
  },
  {
    path: PssRoutePath.AprsAttendanceManage,
    name: "Attendance Management",
    component: PssAprsAttendanceManage,
  },

  // Device Call
  {
    path: PssRoutePath.DeviceCall,
    name: "Communication Device Call",
    component: PssAprsDeviceCall,
  },
  {
    path: PssRoutePath.DeviceCallTablePrint,
    name: "Print",
    component: PssAprsDeviceTablePrint,
  },
  {
    path: PssRoutePath.DeviceCallRecord,
    name: "Communication Device Call Record",
    component: PssAprsDeviceCallRecord,
  },
  {
    path: PssRoutePath.DeviceCallRecordTablePrint,
    name: "Print",
    component: PssAprsDeviceRecordTablePrint,
  },
  {
    path: PssRoutePath.DeviceCallTablePrint,
    name: "Print",
    component: PssAprsDeviceTablePrint,
  },
  {
    path: PssRoutePath.DeviceCallReportRegister,
    name: "Add New Report",
    component: PssAprsDeviceCallRegister,
  },
  {
    path: PssRoutePath.DeviceCallDetail,
    name: "Summary",
    ids: ["deviceCallId"],
    component: PssAprsDeviceCallDetail,
  },
  {
    path: PssRoutePath.DeviceCallRecordDetail,
    name: "Summary",
    ids: ["deviceCallId"],
    component: PssAprsDeviceCallDetailRecord,
  },
  {
    path: PssRoutePath.DeviceCallPrint,
    name: "Print",
    ids: ["deviceCallId"],
    component: PssAprsDeviceCallPrint,
  },
  {
    path: PssRoutePath.DeviceCallRecordPrint,
    name: "Print",
    ids: ["deviceCallId"],
    component: PssAprsDeviceCallRecordPrint,
  },
  {
    path: PssRoutePath.DeviceCallManage,
    name: "Device Call Management",
    component: PssAprsDeviceCallManage,
  },

  // Daily Vehicle
  {
    path: PssRoutePath.VehicleInspection,
    name: "Daily Vehicle Inspection Record",
    component: PssAprsVehicle,
  },
  {
    path: PssRoutePath.VehicleInspectionDetail,
    name: "Summary",
    ids: ["vehicleId"],
    component: PssAprsVehicleDetail,
  },
  {
    path: PssRoutePath.VehicleInspectionPrint,
    name: "Print",
    ids: ["vehicleId"],
    component: PssAprsVehiclePrint,
  },
  {
    path: PssRoutePath.VehicleInspectionManage,
    name: "Daily Vehicle Inspection Management",
    component: PssAprsVehicleManage,
  },

  // UCUX
  {
    path: PssRoutePath.Ucux,
    name: "Inspection Notice Record",
    component: PssAprsUcux,
  },
  {
    path: PssRoutePath.UcuxPrintListPreview,
    name: "Print Inspection Notice Preview List",
    component: PssAprsUcuxPrintListPreview,
  },
  {
    path: PssRoutePath.UcuxManage,
    name: "Inspection Notice Management",
    component: PssAprsUcuxManage,
  },
  {
    path: PssRoutePath.UcuxOffenseById,
    name: "Offense ",
    // key: "offenseId",
    ids: ["offenseId"],
    component: PssAprsUcuxOffenseDetail,
  },
  {
    path: PssRoutePath.UcuxById,
    name: "Summary",
    // key: "ucuxId",
    ids: ["ucuxId"],
    component: PssAprsUcuxById,
  },
  {
    path: PssRoutePath.UcuxPrintById,
    name: "Print",
    // key: "ucuxId",
    ids: ["ucuxId"],
    component: PssAprsUcuxPrintById,
  },

  // PssAprsReferences

  // Address and Phone No
  {
    path: PssRoutePath.RefAddressPhoneNo,
    name: "Address & Phone No Management",
    component: PssAprsReferencesAddressPhoneNo,
  },
  {
    path: PssRoutePath.RefAddressPhoneNoRegister,
    name: "Address & Phone No - Add New Item",
    component: PssAprsReferencesAddressPhoneNoRegister,
  },
  {
    path: PssRoutePath.RefAddressById,
    name: "Address & Phone No - Edit Item",
    ids: ["addPhoneNoId"],
    component: PssAprsReferencesAddressPhoneNoAccount,
  },
  {
    path: PssRoutePath.RefAddressPhoneNoAccount,
    name: "Account:",
    key: "addPhoneNoId",
    ids: ["addPhoneNoId"],
    component: PssAprsReferencesAddressPhoneNoAccount,
  },

  //Company Vehicle
  {
    path: PssRoutePath.RefCompanyVehicle,
    name: "Company Vehicle Management",
    component: PssAprsReferencesCompanyVehicle,
  },
  {
    path: PssRoutePath.RefCompanyVehicleRegister,
    name: "Company Vehicle - Add New Item",
    component: PssAprsReferencesCompanyVehicleRegister,
  },
  {
    path: PssRoutePath.RefCompanyVehicleById,
    name: "Company Vehicle - Edit Item",
    ids: ["companyVehicleId"],
    component: PssAprsReferencesCompanyVehicleAccount,
  },
  {
    path: PssRoutePath.RefCompanyVehicleAccount,
    name: "Company Vehicle - Account",
    component: PssAprsReferencesCompanyVehicleAccount,
  },

  //FAQ
  {
    path: PssRoutePath.RefQuestion,
    name: "FAQ Management",
    component: PssAprsReferencesQuestion,
  },
  {
    path: PssRoutePath.RefQuestionRegister,
    name: "FAQ - Add New Item",
    component: PssAprsReferencesQuestionRegister,
  },
  {
    path: PssRoutePath.RefQuestionAccount,
    name: "FAQ - Account",
    component: PssAprsReferencesQuestionAccount,
  },
  {
    path: PssRoutePath.RefFAQById,
    name: "FAQ - Edit Item",
    ids: ["FAQId"],
    component: PssAprsReferencesQuestionAccount,
  },

  //Police Law
  {
    path: PssRoutePath.RefPoliceLaw,
    name: "Police Law Management",
    component: PssAprsReferencesPoliceLaw,
  },
  {
    path: PssRoutePath.RefPoliceLawRegister,
    name: "Police Law - Add New Item",
    component: PssAprsReferencesPoliceLawRegister,
  },
  {
    path: PssRoutePath.RefPoliceLawById,
    name: "Police Law - Edit Item",
    ids: ["policeLawId"],
    component: PssAprsReferencesPoliceLawAccount,
  },
  {
    path: PssRoutePath.RefPoliceLawAccount,
    name: "Police Law - Account",
    component: PssAprsReferencesPoliceLawAccount,
  },

  //MFSP
  {
    path: PssRoutePath.RefMfsp,
    name: "MFSP Management",
    component: PssAprsReferencesMfsp,
  },
  {
    path: PssRoutePath.RefMfspRegister,
    name: "MFSP - Add New Item",
    component: PssAprsReferencesMfspRegister,
  },
  {
    path: PssRoutePath.RefMfspById,
    name: "MFSP - Edit Item ",
    ids: ["mfspId"],
    component: PssAprsReferencesMfspAccount,
  },
  {
    path: PssRoutePath.RefMfspAccount,
    name: "MFSP - Account",
    component: PssAprsReferencesMfspAccount,
  },
  //SOP
  {
    path: PssRoutePath.RefSop,
    name: "SOP Management",
    component: PssAprsReferencesSop,
  },
  {
    path: PssRoutePath.RefSopRegister,
    name: "SOP - Add New Item",
    component: PssAprsReferencesSopRegister,
  },
  {
    path: PssRoutePath.RefSopById,
    name: "SOP - Edit Item ",
    ids: ["sopId"],
    component: PssAprsReferencesSopAccount,
  },
  {
    path: PssRoutePath.RefMfspAccount,
    name: "MFSP - Account",
    component: PssAprsReferencesMfspAccount,
  },


  //ISPS
  {
    path: PssRoutePath.RefIsps,
    name: "ISPS Management",
    component: PssAprsReferencesIsps,
  },
  {
    path: PssRoutePath.RefIspsRegister,
    name: "ISPS References Details - Add New Item",
    component: PssAprsReferencesIspsRegister,
  },
  {
    path: PssRoutePath.RefIspsDetail,
    name: "Details",
    ids: ["ispsId"],
    component: PssAprsReferencesIspsDetail,
  },
  {
    path: PssRoutePath.RefIspsById,
    name: "ISPS References Details - Edit Item",
    ids: ["ispsId"],
    component: PssAprsReferencesIspsAccount,
  },

  // Logo
  {
    path: PssRoutePath.LogoPicture,
    name: "Logo Management",
    component: PssLogoPicture,
  },
  // Assignee Details
  {
    path: PssRoutePath.Assignee,
    name: "Assignee Management",
    component: PssAssigneeDetails,
  },

  //User Records
  {
    path: PssRoutePath.UserRecords,
    name: "User Records",
    component: PssAprsUserRecords,
  },

  {
    path: PssRoutePath.UserRecordsDetail,
    name: "Details",
    component: PssAprsUserRecordsDetail,
  },

  //Vehicle Records
  {
    path: PssRoutePath.VehicleRecords,
    name: "Vehicle Records",
    component: PssAprsVehicleRecords,
  },
];

export default pssRoutes;
